<template>
  <b-dropdown-item
      v-if="!menuitem.IsDivider"
      :name="'menu_' + menuitem.Name"
      :id="'menu:' + menuitem.Name"
      :href="menuitem.Link"
  >{{ menuitem.Name }}</b-dropdown-item>
  <b-dropdown-divider v-else-if="menuitem.IsDivider"></b-dropdown-divider>
</template>

<script>
import { BDropdownItem, BDropdownDivider } from "bootstrap-vue";
export default {
  components: {
    BDropdownItem,
    BDropdownDivider,
  },
  name: "UserMenuItem",
  props: {
    menuitem: Object,
    useInternalRoutes: Boolean,
  },
  data: function () {
    return {
      loadTime: "d",
    };
  },
};
</script>

<style></style>
